export default __webpack_public_path__ + "static/media/Icon-4.768c4df8.gif";